/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Record_NameInputs */



/**
* | output |
* | --- |
* | "Name" |
*
* @param {Canvas_Domain_Record_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_record_name = /** @type {((inputs?: Canvas_Domain_Record_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Record_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Name")
	return /** @type {LocalizedString} */ ("Name")
});